<template>
  <div>
    <rabbey-table-3
      show-summary
      sum-text="Total por Mes"
      :data="reportData"
      :columns="reportColumns"
      :actions="reportActions"
      :loading="reportDataLoading"
    />
  </div>
</template>

<script>
import { columns } from "@/columns/InternalRequestReportByModules/InternalRequestReportByModuleColumns";

export default {
  name: "InternalRequestByModuleMonthlyReportTable",
  props: {
    YearFilter: {
      type: [Number, String],
      default: "",
      required: false
    },
    DirectionFilter: {
      type: [Number, String],
      default: "",
      required: false
    },
    EmployFilter: {
      type: [Number, String],
      default: "",
      required: false
    }
  },
  data() {
    return {
      reportData: [],
      reportColumns: columns(this),
      reportActions: [],
      reportDataLoading: false,
      months: {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12
      }
    };
  },
  computed: {
    SelectedYear() {
      return this.YearFilter;
    },
    SelectedDirection() {
      return this.DirectionFilter;
    },
    SelectedEmploy() {
      return this.EmployFilter;
    }
  },
  mounted() {
    this.GetReportData();
  },

  methods: {
    async GetReportData() {
      const body = {
        params: {
          Year: this.SelectedYear,
          DirectionId: this.SelectedDirection,
          EmployId: this.SelectedEmploy
        }
      };
      this.reportDataLoading = true;
      await this.$http
        .get(
          "/api/InternalServiceRequest/GetInternalRequestReportByModule",
          body
        )
        .then((resp) => {
          this.reportData = resp.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.reportDataLoading = false;
        });
    },
    OpenDialodDetailList(column, row) {
      this.$emit(
        "OpeningDetailDialosg",
        true,
        this.months[column.property],
        row.ModuleId,
        row.ModuleName,
        row.ReportId,
        row.ReportNsme
      );
    }
  },
  watch: {
    SelectedYear() {
      this.GetReportData();
    },
    SelectedDirection() {
      this.GetReportData();
    },
    SelectedEmploy() {
      this.GetReportData();
    }
  }
};
</script>

<style scoped></style>
